module.exports = __webpack_public_path__ + "static/media/swatch.c65ce00c.png";